export enum ConnectionStatus {
    connected = 0,
    notConnected = 10,
    waitingForConnection = 20,
    wrongInformation = 30,
    missingInformation = 40,
}
